import { useNavigate } from "react-router-dom";
import { MenuStyle } from "./style";
import { Avatar, MenuItem, Typography } from "@mui/material";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import LogoutIcon from "@mui/icons-material/Logout";
import axios from "axios";
import { useContext, useState } from "react";
import Context from "../../scripts/context/User";
import { WalletContext } from "../../scripts/context/WalletContext";
import { initWeb3State } from "../../scripts/constants.js";
import toast from "react-hot-toast";

export default function DropMenu({ anchorElUser, setAnchorElUser }) {
  const { globalState, setGlobalState } = useContext(Context);
  const navigate = useNavigate();
  const handleCloseUserMenu = () => setAnchorElUser(null);
  const [loading, setLoading] = useState(false);
  const InvitationCode = `${window.location.origin}/register/personal-information?invitation_code=${globalState.user.invitation_code}`;
  const { setWeb3 } = useContext(WalletContext);

  const handleLogout = () => {
    setLoading(true);

    axios
      .post("/logout")
      .then(() => {
        setGlobalState({
          user: null,
          redirect_uri: "",
          registration_step: 0,
        });
        navigate("/login");
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
        handleCloseUserMenu();
        setLoading(false);
        setWeb3(initWeb3State);
      })
      .catch(({ response }) => {
        setLoading(false);
        toast.error(response.data.message);
        handleCloseUserMenu();
      });
  };

  return (
    <MenuStyle
      sx={{
        mt: "45px",
        ".MuiButtonBase-root:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.15)",
        },
      }}
      id="menu-appbar"
      anchorEl={anchorElUser}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      keepMounted
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={Boolean(anchorElUser)}
      onClose={handleCloseUserMenu}
    >
      <MenuItem className="avatar-name">
        <Avatar
          alt={globalState.user.full_name}
          src={globalState.user.avatar}
        />
        <Typography textAlign="center">{globalState.user.full_name}</Typography>
      </MenuItem>
      {globalState.registration_step === -1 && (
        <MenuItem
          className="profile"
          onClick={() => {
            navigate("/profile");
          }}
        >
          <Typography textAlign="center">
            <PermIdentityIcon />
            Profile
          </Typography>
        </MenuItem>
      )}
      {globalState.user?.invitation_code && (
        <MenuItem
          className="invitation_code"
          onClick={() => {
            navigator.clipboard
              .writeText(InvitationCode)
              .then(() => {
                toast.success("Copied to clipboard");
              })
              .catch(() => {
                console.log(InvitationCode);
              });
          }}
        >
          <Typography textAlign="center">
            <i
              className="fa-solid fa-copy"
              style={{
                fontSize: "1rem",
                marginInlineStart: "3px",
              }}
            />
            <span className="the-code">{globalState.user.invitation_code}</span>
            <span className="invitation_code-text">Invitation Link</span>
          </Typography>
        </MenuItem>
      )}
      <hr />
      <MenuItem
        className="profile"
        onClick={() => {
          navigate("/tickets");
        }}
      >
        <Typography textAlign="center">
          <HelpOutlineIcon />
          Help Center
        </Typography>
      </MenuItem>
      <MenuItem className="profile" onClick={!loading && handleLogout}>
        <Typography textAlign="center">
          <LogoutIcon />
          Sign Out{loading && "..."}
        </Typography>
      </MenuItem>
    </MenuStyle>
  );
}
